// Shared constants and utilities
import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001'}/api`;

// Utility per verificare se il token è valido
export const isTokenValid = () => {
  const token = localStorage.getItem('token');
  if (!token) return false;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp > Date.now() / 1000;
  } catch {
    return false;
  }
};

// Utility per ottenere headers autorizzati
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return { 'Authorization': `Bearer ${token}` };
};

// Intervalli di sincronizzazione disponibili (in secondi)
export const SYNC_INTERVALS = [
  { value: 30, label: 'Ogni 30 secondi' },
  { value: 60, label: 'Ogni minuto' },
  { value: 300, label: 'Ogni 5 minuti' },
  { value: 900, label: 'Ogni 15 minuti' },
  { value: 1800, label: 'Ogni 30 minuti' },
  { value: 3600, label: 'Ogni ora' },
  { value: 7200, label: 'Ogni 2 ore' },
  { value: 14400, label: 'Ogni 4 ore' },
  { value: 21600, label: 'Ogni 6 ore' },
  { value: 43200, label: 'Ogni 12 ore' },
  { value: 86400, label: 'Ogni 24 ore' },
];

// Nomi mesi italiano
export const MONTH_NAMES = ['', 'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
                           'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

// Formatta intervallo in label leggibile
export const formatIntervalLabel = (seconds) => {
  const interval = SYNC_INTERVALS.find(i => i.value === seconds);
  if (interval) return interval.label;
  
  if (seconds < 60) return `${seconds} secondi`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)} minuti`;
  return `${Math.floor(seconds / 3600)} ore`;
};
